import { useEffect, useState } from "react";
import { Button, DatePicker } from "antd";
import ProductItem from "./ProductItem";
import CashierItem from "./CashierItem";
import BarChart from "./BarChart";
import PieChart from "./PieChart";
import GroupedColumn from "./GroupedColumn";
import dayjs from "dayjs";

const TopCards = [
  {
    label: "Хамгийн өндөр борлуулалттай бараа",
    propvalue: "highAmount",
  },
  {
    label: "Хамгийн олон зарагдсан бараа",
    propvalue: "highQty",
    suffix: "ш",
  },
];

const SecondCards = [
  {
    label: "Хамгийн их үлдэгдэлтэй бараа",
    propvalue: "highStock",
  },
  {
    label: "Хамгийн бага үлдэгдэлтэй бараа",
    propvalue: "lowStock",
  },
];

const Tabs = [
  {
    value: 1,
    label: "Өнөөдөр",
  },
  {
    value: 2,
    label: "Сар",
  },
  {
    value: 3,
    label: "Жил",
  },
];

function SaleDashboard(props) {
  const [type, setType] = useState(null);
  const [sdate, setsDate] = useState(dayjs());
  const [edate, seteDate] = useState(dayjs());
  const [ttlAmt, setTtlAmt] = useState(0);

  useEffect(() => {
    if (type === 1) {
      setsDate(dayjs());
      seteDate(dayjs());
    } else if (type === 2) {
      setsDate(dayjs().subtract(1, "month"));
      seteDate(dayjs());
    } else if (type === 3) {
      setsDate(dayjs().subtract(1, "year"));
      seteDate(dayjs());
    }
  }, [type]);

  useEffect(() => {
    let amt = 0;
    props.resdashboardstore &&
      props.resdashboardstore.map((item) => {
        amt += item.amount;
      });
    setTtlAmt(amt);
  }, [props.resdashboardstore]);

  useEffect(() => {
    if (sdate && edate)
      handleReload({
        sdate: dayjs(sdate).format("YYYY-MM-DD"),
        edate: dayjs(edate).format("YYYY-MM-DD"),
      });
  }, [sdate, edate]);

  const handleReload = ({ sdate, edate }) => {
    props.request({
      url: `/dashboard/fourproduct/${sdate}/${edate}`,
      model: "dashboardbest",
    });
    props.request({
      url: `/dashboard/twoproduct`,
      model: "dashboardtwo",
    });
    props.request({
      url: `/dashboard/cashier/${sdate}/${edate}`,
      model: "dashboardstore",
    });
    props.request({
      url: `/dashboard/sale/pie/${sdate}/${edate}`,
      model: "dashboardpie",
    });
    props.request({
      url: `/dashboard/product/${sdate}/${edate}`,
      model: "dashoboardproduct",
    });
    props.request({
      url: `/dashboard/category/${sdate}/${edate}`,
      model: "dashoboardcategory",
    });
    props.request({
      url: `/dashboard/cashdetail/${sdate}/${edate}`,
      model: "dashoboardcashdetail",
    });
  };

  return (
    <div className="grid lg:grid-cols-4 lg:gap-4 sm:grid-cols-1 w-full h-full">
      <div className="lg:col-span-4 lg:gap-2 sm:w-full lg:flex">
        <DatePicker
          allowClear={false}
          value={sdate}
          className="sm:w-full lg:w-40"
          onChange={(val) => setsDate(val)}
        />
        <DatePicker
          allowClear={false}
          value={edate}
          className="sm:w-full lg:w-40 sm:mt-2 lg:mt-0"
          onChange={(val) => seteDate(val)}
        />
        {Tabs.map((item, i) => (
          <Button
            className="lg:w-20 sm:w-full flex items-center justify-center sm:mt-2 lg:mt-0"
            onClick={() => setType(item.value)}
            type={item.value === type ? "primary" : "dashed"}
          >
            {item.label}
          </Button>
        ))}
      </div>
      <div className="sm:col-span-2 grid lg:grid-cols-2 lg:gap-2 w-full relative">
        {TopCards.map((item, i) => (
          <ProductItem
            loading={props.isdashboardbest}
            label={item.label}
            suffix={item.suffix}
            type={1}
            data={
              props.resdashboardbest
                ? props.resdashboardbest[item.propvalue]
                : {}
            }
          />
        ))}
      </div>
      <div className="sm:col-span-2 grid lg:grid-cols-2 lg:gap-2 w-full relative">
        {SecondCards.map((item, i) => (
          <ProductItem
            loading={props.isdashboardtwo}
            label={item.label}
            suffix={item.suffix}
            type={2}
            data={
              props.resdashboardtwo ? props.resdashboardtwo[item.propvalue] : {}
            }
          />
        ))}
      </div>
      <div className="col-span-2 gap-5">
        <div className="bg-white rounded-lg p-5 border-solid border-2 border-primary drop-shadow-xl sm:mt-4">
          <span className="font-bold text-lg ">
            Борлуулалт /төлбөрийн төрлөөр/
          </span>
          <div className="mt-4">
            <GroupedColumn
              data={
                props.resdashoboardcashdetail
                  ? props.resdashoboardcashdetail
                  : []
              }
              x="name"
              y="amount"
              name="payname"
            />
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 border-solid border-2 border-primary drop-shadow-xl mt-3 sm:mt-4">
          <span className="font-bold text-lg ">Борлуулалт /ангиллаар/</span>
          <div className="mt-4">
            <BarChart
              color="#0062FF"
              data={
                props.resdashoboardcategory ? props.resdashoboardcategory : []
              }
              x="name"
              y="amount"
            />
          </div>
        </div>
      </div>
      <div
        className={`lg:grid lg:grid-cols-2 gap-5 col-span-2 bg-white rounded-lg transition-all`}
      >
        <div className="bg-white rounded-lg p-5 border-solid border-2 border-primary drop-shadow-xl col-span-1 w-full sm:mt-4">
          <div className="flex justify-center">
            <span className="text-lg font-bold"></span>
          </div>
          <div className="flex flex-col mt-2 justify-center">
            <span className="font-bold text-lg">
              Дэлгүүрүүд нийт: {Intl.NumberFormat().format(ttlAmt ? ttlAmt : 0)}
              ₮
            </span>
            <span className="text-grey">/хамгийн өндөр борлуулалттай/</span>
            {props.resdashboardstore &&
              props.resdashboardstore.map((item) => (
                <CashierItem data={item} />
              ))}
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 border-solid border-2 border-primary drop-shadow-xl col-span-1 w-full sm:mt-4">
          <div className="flex justify-center">
            <span className="text-lg font-bold"></span>
          </div>
          <div>
            <PieChart
              data={props.resdashboardpie ? props.resdashboardpie : []}
            />
          </div>
        </div>
        <div className="bg-white rounded-lg p-5 border-solid border-2 border-primary drop-shadow-xl col-span-2 sm:mt-4">
          <span className="font-bold text-lg">Борлуулалт /Бараагаар/</span>
          <div className="mt-4">
            <BarChart
              color="#3DD598"
              data={
                props.resdashoboardproduct ? props.resdashoboardproduct : []
              }
              x="productname"
              y="amount"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SaleDashboard;
